import { DateTime } from 'luxon'

// Sorts normalized audit targets (dealers + trailer locations) ascending by their
// field-audit-due-on date. Targets without a due date sort to the end.
const sortByFieldAuditDueOn = (auditTargets) => {
  return [...auditTargets].sort((first, second) => {
    const firstDueOn = first.attributes['field-audit-due-on']
    const secondDueOn = second.attributes['field-audit-due-on']

    if (!firstDueOn && !secondDueOn) return 0
    if (!firstDueOn) return 1
    if (!secondDueOn) return -1

    return DateTime.fromISO(firstDueOn).toMillis() - DateTime.fromISO(secondDueOn).toMillis()
  })
}

export default sortByFieldAuditDueOn
